import { find } from 'fxjs/es';
import { NewMakerSGuide } from '../../../S/module/NewMakerSGuide.js';

export const findBp = (base_product_id) => {
  return find((am) => {
    return base_product_id == am.base_product_id;
  }, NewMakerSGuide.GUIDE_DATA.ambiguous);
};
